export { default } from './components/Footer/Footer';
